// In-memory roster snapshot (survives route unmount; keyed by viewer context).

const store = new Map();
const MAX_ENTRIES = 8;
/** Bump when roster row payload shape changes (e.g. donorGem). */
const ROSTER_CACHE_SCHEMA = 3;

/**
 * @param {{ userId?: number|null, isViewAsActive?: boolean, viewAsUserId?: number|null }} ctx
 */
export function rosterSessionCacheKey(ctx) {
  const uid = ctx.userId ?? 0;
  const vid = ctx.isViewAsActive ? (ctx.viewAsUserId ?? 0) : 0;
  return `u:${uid}:v:${vid}`;
}

/**
 * @param {string} key
 * @returns {{
 *   merged: object[],
 *   page: number,
 *   pageCount: number,
 *   stats: object,
 *   search: string,
 *   trainingsLoaded: boolean
 * }|null}
 */
export function getRosterSessionCache(key) {
  const entry = store.get(key);
  if (!entry || entry.schema !== ROSTER_CACHE_SCHEMA) {
    if (entry) store.delete(key);
    return null;
  }
  return entry;
}

/** @param {string} key */
export function getRosterSessionBoot(key) {
  return getRosterSessionCache(key);
}

/**
 * @param {string} key
 * @param {object} payload
 */
export function setRosterSessionCache(key, payload) {
  if (!key) return;
  store.set(key, {
    schema: ROSTER_CACHE_SCHEMA,
    merged: payload.merged ?? [],
    page: payload.page ?? 0,
    pageCount: payload.pageCount ?? 1,
    stats: payload.stats ?? { total: 0, exclusive: 0, certified: 0 },
    search: typeof payload.search === 'string' ? payload.search : '',
    trainingsLoaded: payload.trainingsLoaded !== false,
    at: Date.now()
  });
  if (store.size > MAX_ENTRIES) {
    let oldestKey = null;
    let oldestAt = Infinity;
    for (const [k, v] of store.entries()) {
      if (v.at < oldestAt) {
        oldestAt = v.at;
        oldestKey = k;
      }
    }
    if (oldestKey) store.delete(oldestKey);
  }
}

/** @param {string} [key] */
export function clearRosterSessionCache(key) {
  if (key) store.delete(key);
  else store.clear();
}
